import React from "react";
import "./Prices.scss";

const Prices = ({ hit }) => {
    return (
        <div className="search-hit__prices">
            <div className="search-hit__price">
                {hit.displayFromPrice ? (
                    <span className="search-hit__from-price">ab </span>
                ) : null}

                {hit.priceDisplay}
                {hit.currencyAbbreviation}
            </div>
            <div className="search-hit__price-pseudo">
                {hit.savingPercentNumeric >= 5  ? (
                    <>
                        <span className="search-hit__price-discount">
                            {hit.pseudopriceDisplay}
                            {hit.currencyAbbreviation}*
                        </span>
                        <span className="search-hit__savings">
                            {hit.savingPercentDisplay}% GESPART*
                        </span>
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default Prices;
